import { Avatar } from '../avatar';
import { Space } from '../space';

type P = {
  titles: Title[];
};

type Title = {
  email?: string;
  id?: string;
  title?: string;
  url?: string;
};

const AvatarList = ({ titles }: P) => (
  <Space size={16}>
    <Space size={-20}>
      {titles.slice(0, 5).map((title: Title) => (
        <Avatar key={`avatar_list_${title.id}`} size="lg" src={title.url}>
          {title.title?.slice(0, 2).toUpperCase()}
        </Avatar>
      ))}
    </Space>

    {titles.length > 5 && <span>+ {titles.length - 5}</span>}
  </Space>
);

export default AvatarList;
